import { useState, useEffect, useContext } from 'react';
import ProjectDetails from './ProjectDetails';
import UserFeatures from './UserFeatures';
import styles from './index.module.css'; // Import the CSS module
import { ThemeContext } from "../../context/ThemeContext";

export default function Project(props) {
  const [isProjDetailsVisible, setIsProjDetailsVisible] = useState(false);
  const [isUserFeaturesVisible, setIsUserFeaturesVisible] = useState(false);

  function showProjectDetails() {
    setIsProjDetailsVisible(true);
    setIsUserFeaturesVisible(false);
  }

  function showUserFeatures() {
    setIsProjDetailsVisible(false);
    setIsUserFeaturesVisible(true);
  }

  const { isDarkMode } = useContext(ThemeContext);
  const [theme, setTheme] = useState(isDarkMode);
  
  useEffect(() => {
    setTheme(isDarkMode);
    if (isProjDetailsVisible || isUserFeaturesVisible) {
      window.document.body.style.overflowY = "hidden";
    } else {
      window.document.body.style.overflowY = "auto";
    }
  }, [isProjDetailsVisible, isUserFeaturesVisible, isDarkMode]);
  const backgroundColorLightMode = "white"
  const backgroundColorDarkMode = "black"
  const textColorLightMode = "black"
  const textColorDarkMode = "white"

  return (
    <>
      {isProjDetailsVisible && (
        <ProjectDetails 
          productId={props.productId} 
          setIsProjDetailsVisible={setIsProjDetailsVisible} 
        />
      )}

      {isUserFeaturesVisible && (
        <UserFeatures 
          productId={props.productId} 
          setIsUserFeaturesVisible={setIsUserFeaturesVisible} 
        />
      )}

        <tr style={{ background: theme ? backgroundColorDarkMode : backgroundColorLightMode}} className={styles.project}>
        <td style={{color: theme ? textColorDarkMode : textColorLightMode }} >{props.projectName}</td>
        <td style={{color: theme ? textColorDarkMode : textColorLightMode }}  >{props.startDate}</td>      
        <td style={{color: theme ? textColorDarkMode : textColorLightMode }} >{props.currentDecisions || 0}</td>
        <td style={{color: theme ? textColorDarkMode : textColorLightMode }} >{props.maxDecisions || 'N/A'}</td>
        <td style={{color: theme ? textColorDarkMode : textColorLightMode  }} >{props.question || 0}</td>
        <td style={{ padding: '5px', textAlign: 'center' }}>
          <button style={{ padding: '0', margin: '0', lineHeight: 'normal' }} onClick={showProjectDetails}>
            Show Table
          </button>
        </td>
        <td style={{ padding: '5px', textAlign: 'center' }}>
          <button style={{ padding: '0', margin: '0', lineHeight: 'normal' }} onClick={showUserFeatures}>
            Show Table
          </button>
        
        
      
      
      
        </td>

      </tr>
    </>
  );
}
